import axios from 'axios';

import { headers, ledgerServiceUrl } from '../../config';


export function getIdempotentKey() {
    return axios.get(`${ledgerServiceUrl}/dpk`, { headers: headers() })
}